module.exports = __webpack_public_path__ + "static/aemc-logo-add9e3d57bf75fff702e23ff4827036b.svg";